// extracted by mini-css-extract-plugin
export default {"container":"j6-z","topReviewHeading":"k6-z","criticalReview":"l6-z","favorableReview":"m6-z","vsSeparator":"n6-z"};